module.exports = __webpack_public_path__ + "img/spirometer.92513229.png";